module.exports = __webpack_public_path__ + "static/media/SwipeLeft.38be5c57.png";